var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ViewChild, Input } from '@angular/core';
import * as _ from 'lodash';
import { ResizableElementSettingModal } from '../base/resizable-element-setting-modal';
import { SecuritySettingAdapter } from '../shared/control/security-setting.adapter';
import { ActionButtonType } from '../../../view-data/components/toggle-view/action-button-type';
import { finalize } from 'rxjs/operators';
import { ActionButtonTypeHelper } from './action-button-type-helper';
import { ConfigureViewType } from '../../designer/shared/configure-view-type';
import { DynamicDisplayModel } from '../../../../shared/dynamic-conduct-model/dynamic-display/dynamic-display-model';
var ToggleViewSettingModalComponent = /** @class */ (function (_super) {
    __extends(ToggleViewSettingModalComponent, _super);
    function ToggleViewSettingModalComponent(injector, configureViewService) {
        var _this = _super.call(this, injector, 'toggleViewSettingModal') || this;
        _this.configureViewService = configureViewService;
        _this.getConfigureViewTypeCallback = function (viewType) {
            _this.currentConfigureViewType = viewType;
            _this.actionButtonTypes = _this.getActionButtonTypes();
        };
        return _this;
    }
    Object.defineProperty(ToggleViewSettingModalComponent.prototype, "selectedActionButtonType", {
        get: function () {
            return this._actionButtonType;
        },
        set: function (v) {
            if (this._actionButtonType === +v) {
                return;
            }
            this._actionButtonType = v;
            this.actionButtonText = ActionButtonTypeHelper.getButtonValue(v);
            this.loadConfigureViewNames();
        },
        enumerable: true,
        configurable: true
    });
    ToggleViewSettingModalComponent.prototype.onShown = function () {
        $(this.textInput.nativeElement).focus();
    };
    ToggleViewSettingModalComponent.prototype.ngOnInit = function () {
        this.actionButtonType = ActionButtonType;
        abp.event.on('designer:configureViewType', this.getConfigureViewTypeCallback);
    };
    ToggleViewSettingModalComponent.prototype.ngOnDestroy = function () {
        abp.event.off('designer:configureViewType', this.getConfigureViewTypeCallback);
    };
    ToggleViewSettingModalComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        this.editedComponent = editedComponent;
        this.configureId = editedComponent.configureId;
        var componentData = editedComponent.model.data;
        this.loadBasicInfo(componentData);
        this.loadGraphSetting(componentData);
        this.loadControlSetting(componentData);
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
            _this.enableSettingCmp.init(editedComponent);
        }, 500);
        this.loadDynamicSetting(editedComponent.model.data);
        this.modal.show();
    };
    ToggleViewSettingModalComponent.prototype.getActionButtonTypes = function () {
        var result = ActionButtonTypeHelper.getButtonTypes();
        if (this.currentConfigureViewType === ConfigureViewType.PopView) {
            result = _.filter(result, function (item) {
                return item.id !== ActionButtonType.toggle;
            });
        }
        else {
            result = _.filter(result, function (item) {
                return item.id !== ActionButtonType.close && item.id !== ActionButtonType.control;
            });
        }
        return result;
    };
    ToggleViewSettingModalComponent.prototype.loadConfigureViewNames = function () {
        var _this = this;
        var configureViewTypeQuery = +this._actionButtonType === ActionButtonType.toggle ?
            this.currentConfigureViewType : ConfigureViewType.PopView;
        abp.ui.setBusy();
        this.configureViewService.getConfigureViewsNamesByType(this.configureId, configureViewTypeQuery)
            .pipe(finalize(function () { return abp.ui.clearBusy(); }))
            .subscribe(function (result) {
            _this.viewNames = result.items;
            _this.filterViewNames();
            _this.setSelectedViewId();
        });
    };
    ToggleViewSettingModalComponent.prototype.filterViewNames = function () {
        var _this = this;
        if (this.currentConfigureViewType !== ConfigureViewType.PopView) {
            return;
        }
        if (+this._actionButtonType === ActionButtonType.pop) {
            this.viewNames = _.filter(this.viewNames, function (item) { return item.id !== _this.currentConfigureViewId; });
        }
        if (+this._actionButtonType === ActionButtonType.close
            || +this._actionButtonType === ActionButtonType.control) {
            this.viewNames = _.filter(this.viewNames, function (item) { return item.id === _this.currentConfigureViewId; });
        }
    };
    ToggleViewSettingModalComponent.prototype.setSelectedViewId = function () {
        if (+this._actionButtonType === ActionButtonType.close || +this._actionButtonType === ActionButtonType.control) {
            this.selectedViewId = this.currentConfigureViewId;
            return;
        }
        var componentData = this.editedComponent.model.data;
        var view = this.viewNames.find(function (v) { return v.id === componentData.viewId; });
        if (view) {
            this.selectedViewId = componentData.viewId;
        }
        else if (null != componentData.viewIndex) {
            view = this.viewNames.find(function (v) { return v.index === componentData.viewIndex; });
            if (view) {
                this.selectedViewId = view.id;
            }
        }
        else {
            this.selectedViewId = undefined;
        }
    };
    ToggleViewSettingModalComponent.prototype.loadDynamicSetting = function (componentData) {
        if (null != componentData.dynamicSetting) {
            this.dynamicSetting = _.cloneDeep(componentData.dynamicSetting);
            DynamicDisplayModel.addDefaultForRotationTranslation(this.dynamicSetting);
        }
        else {
            this.dynamicSetting = DynamicDisplayModel.default();
        }
    };
    ToggleViewSettingModalComponent.prototype.loadBasicInfo = function (componentData) {
        this.labelInfo = _.cloneDeep(componentData.label);
        var actionButtonType = _.cloneDeep(componentData.actionButtonType);
        var defaultActionButtonType = ActionButtonType.toggle;
        if (this.currentConfigureViewType === ConfigureViewType.PopView) {
            defaultActionButtonType = ActionButtonType.pop;
        }
        actionButtonType = actionButtonType ? actionButtonType : defaultActionButtonType;
        this.selectedActionButtonType = actionButtonType;
    };
    ToggleViewSettingModalComponent.prototype.loadGraphSetting = function (componentData) {
        this.useGraph = componentData.useGraph;
        if (null != componentData.graphSetting) {
            this.graphSetting = _.cloneDeep(componentData.graphSetting);
        }
        else {
            this.graphSetting = {};
        }
    };
    ToggleViewSettingModalComponent.prototype.save = function () {
        this.saving = true;
        this.currentDiagram.startTransaction('toggle-view settings');
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(2);
            return;
        }
        if (!this.enableSettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(3);
            return;
        }
        this.saveBasicInfo();
        this.saveGraphSetting();
        this.saveDynamicSetting();
        this.saveControlSetting();
        this.currentDiagram.commitTransaction('toggle-view settings');
        this.close();
    };
    ToggleViewSettingModalComponent.prototype.saveDynamicSetting = function () {
        if (!this.dynamicValidatoinResult) {
            if (this.dynamicSetting.isTranslation !== true) {
                this.dynamicSetting.horizontalTranslation = null;
                this.dynamicSetting.verticalTranslation = null;
            }
            else {
                if (this.dynamicSetting.isHorizontalTranslation !== true) {
                    this.dynamicSetting.horizontalTranslation = null;
                }
                if (this.dynamicSetting.isVerticalTranslation !== true) {
                    this.dynamicSetting.verticalTranslation = null;
                }
            }
            if (this.dynamicSetting.isRotation !== true) {
                this.dynamicSetting.rotation = null;
            }
            this.saveComponentProperty('dynamicSetting', this.dynamicSetting);
        }
        else {
            this.notify.error(this.l('Savedfail'));
        }
    };
    ToggleViewSettingModalComponent.prototype.saveBasicInfo = function () {
        var _this = this;
        this.saveComponentProperty('actionButtonType', +this.selectedActionButtonType);
        this.saveComponentProperty('viewId', +this.selectedViewId);
        var view = this.viewNames.find(function (v) { return v.id === +_this.selectedViewId; });
        if (view) {
            this.saveComponentProperty('viewIndex', view.index);
        }
        this.saveComponentProperty('label', this.labelInfo);
    };
    ToggleViewSettingModalComponent.prototype.saveGraphSetting = function () {
        this.saveComponentProperty('useGraph', this.useGraph);
        if (this.useGraph) {
            this.saveComponentProperty('graphSetting', this.graphSetting);
        }
        else {
            this.deleteComponentProperty('graphSetting');
        }
        this.deleteComponentProperty('graphUrl');
    };
    ToggleViewSettingModalComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    ToggleViewSettingModalComponent.prototype.validateChange = function (validatoinResult) {
        this.dynamicValidatoinResult = validatoinResult;
    };
    ToggleViewSettingModalComponent.prototype.loadControlSetting = function (componentData) {
        this.securitySettingData = new SecuritySettingAdapter(componentData, false);
    };
    ToggleViewSettingModalComponent.prototype.saveControlSetting = function () {
        this.controlSettingCmp.save(this.editedComponent.model, true);
    };
    ToggleViewSettingModalComponent.prototype.close = function () {
        this._actionButtonType = undefined;
        _super.prototype.close.call(this);
    };
    __decorate([
        ViewChild('textInput', { static: false })
    ], ToggleViewSettingModalComponent.prototype, "textInput", void 0);
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], ToggleViewSettingModalComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], ToggleViewSettingModalComponent.prototype, "staticTabs", void 0);
    __decorate([
        ViewChild('enableSettingCmp', { static: false })
    ], ToggleViewSettingModalComponent.prototype, "enableSettingCmp", void 0);
    __decorate([
        ViewChild('controlSettingCmp', { static: false })
    ], ToggleViewSettingModalComponent.prototype, "controlSettingCmp", void 0);
    __decorate([
        Input()
    ], ToggleViewSettingModalComponent.prototype, "currentConfigureViewId", void 0);
    __decorate([
        Input()
    ], ToggleViewSettingModalComponent.prototype, "viewWidth", void 0);
    __decorate([
        Input()
    ], ToggleViewSettingModalComponent.prototype, "viewHeight", void 0);
    ToggleViewSettingModalComponent = __decorate([
        Component({
            selector: 'toggle-view-setting-modal',
            styles: [" .graphList { text-align: center; float: left; width: 64px; height: 100px; margin-left: 10px; margin-top: 10px; .graph { width: 64px; height: 64px; border: 2px solid transparent; display: flex; cursor: pointer; justify-content: center; .svgGraph>svg { width: 100%; height: 100%; } img{ width: auto; height: auto; max-width: 100%; max-height: 100%; align-self: center; } } span { font-size: 12px; word-break: break-word; } .graph.selectedGallery { border-color: #2d89ef; } } .inline-control{ display: inline-block; }",
                ".element-setting-base{ .inline-label { margin: 10px 0px 0px 10px; display: inline-block; } .border-group { // border: 1px solid #ddd; padding: 5px; margin-bottom: 0px; } .inline-selector { display: inline-block; margin: 5px 0px; } .inline-variable { display: inline-block; margin: 5px 0px; } .inline-input { display: inline-block; margin: 5px 0px; }     } .date-time-setting-modal { .modal-content { width: 600px; } .cursor-pointer{ cursor: pointer; } .recode-input{ width: calc(100% - 70px); border: 1px solid #d7dbe5;   padding:  5px 10px; } textarea.noResize { resize: none; } } .toggleViewSettingModal { .modal-content { width: 600px; } } .textSettingModal { .modal-content { width: 600px; } } "],
            template: "<div bsModal #settingModal=\"bs-modal\" id=\"toggleViewSettingModal\" class=\"modal fade toggleViewSettingModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"settingModal\" (onShown)=\"onShown()\" (onHidden)=\"onHidden()\" aria-hidden=\"true\" [config]=\"{backdrop: 'static'}\"> <div class=\"modal-dialog\"> <div class=\"modal-content element-setting-base\"> <div class=\"fe-modal-container\"> <form class=\"configure\" *ngIf=\"active\" #toggleViewSettingForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"ViewOperationButton\")}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle design-nav-link\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('Setting')}}\" customClass=\"m-tabs__item\"> <div class=\"fe-modal-content clearfix\"> <div> <div class=\"fe-vertical-label\"> <div class=\"fe-vertical-title\">{{lc(\"ButtonFunciton\")}}:</div> <div class=\"fe-vertical-component\"> <select name=\"actionButtonType\" [(ngModel)]=\"selectedActionButtonType\"> <option *ngFor=\"let actionButtonType of actionButtonTypes\" [value]=\"actionButtonType.id\"> {{lc(actionButtonType.name)}} </option> </select> </div> </div> </div> <div *ngIf=\"selectedActionButtonType != actionButtonType.control\"> <div class=\"fe-vertical-label\"> <div class=\"fe-vertical-title\">{{lc(actionButtonText)}}:</div> <div class=\"fe-vertical-component\"> <select #viewSelector name=\"viewSelector\" [(ngModel)]=\"selectedViewId\"> <option value=\"\"></option> <option *ngFor=\"let viewName of viewNames\" [value]=\"viewName.id\"> {{viewName.name}} </option> </select> </div> </div> </div> <div class=\"margin-top-10\" *ngIf=\"labelInfo&&labelInfo.font\"> <label class=\"form-inline-label\">{{lc(\"Label\")}}:</label> <div class=\"inline-control\"> <font-style [(fontSize)]=\"labelInfo.font.fontSize\" [(fontColor)]=\"labelInfo.font.color\" [(textAlign)]=\"labelInfo.font.textAlign\" [(isUnderline)]=\"labelInfo.font.isUnderline\" [(fontStyle)]=\"labelInfo.font.fontStyle\"></font-style> </div> </div> <div class=\"margin-top-20\" *ngIf=\"labelInfo\"> <textarea class=\"whole-width\" rows=\"6\" name=\"text\" #textInput maxlength=\"500\" [(ngModel)]=\"labelInfo.content\"></textarea> </div> </div> </tab> <tab heading=\"{{lc('Graph')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(graphSettingEventName)\"> <graph-setting [configureId]=\"configureId\" [(useGraph)]=\"useGraph\" [graphSetting]=\"graphSetting\"></graph-setting> </tab> <tab heading=\"{{lc('DynamicSetting')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(dynamicSettingEventName,configureId)\"> <dynamic-conduct [dynamicSetting]=\"dynamicSetting\" [configureId]='configureId' [viewWidth]=\"viewWidth\" [viewHeight]=\"viewHeight\" (validateChange)=\"validateChange($event);\"></dynamic-conduct> </tab> <tab heading=\"{{lc('ControlSetting')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <enable-setting #enableSettingCmp></enable-setting> <control-setting #controlSettingCmp [data]=\"securitySettingData\"></control-setting> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isFixedPositionVisible]='true'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!toggleViewSettingForm.form.valid || dynamicValidatoinResult \" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div> </div> </div>"
        })
    ], ToggleViewSettingModalComponent);
    return ToggleViewSettingModalComponent;
}(ResizableElementSettingModal));
export { ToggleViewSettingModalComponent };
